import React, { useState, useEffect, memo } from "react";
import { StyleSheet, View, TouchableOpacity, BackHandler } from "react-native";
import CustomText from "../accessories/CustomText";
import * as Clipboard from "expo-clipboard";
import Icon from "react-native-vector-icons/FontAwesome";
import EvilIcons from "react-native-vector-icons/EvilIcons";
import {
  InputBox,
  Option,
  Button,
  SmallSpinner,
  Spinner,
  Separator,
} from "../accessories/accessories";
import ArrowSpinner from "../accessories/ArrowSpinner";
import {
  handleAPI,
  FormatPhoneLogin,
  updateWebURL,
  getQueryString
} from "../accessories/CommonFunctions.js";
import ScrollContainer from "../accessories/ScrollContainer";
import { web } from "../accessories/Platform";
import Footer from "../accessories/footer";

const ShareApp = (props) => {
  const { navigation, route } = props;
 
  
  const [shareOption, setShareOption] = useState({ email: true, text: true });
  const [shareDetails, setShareDetails] = useState({
    name: "",
    cellPhone: "",
    email: "",
  });
  const [statusMessage, setStatusMessage] = useState({
    isShow: false,
    messageColor: "green",
    iconName: "check",
  });
  const [showSpinner, setShowSpinner] = useState(false);
  const [validateArray, setValidateArray] = useState([]);

  const handleBackAction = () => {
    if (web) {
      props?.setFloatPage(null);
    } else {
      navigation.navigate(route?.params?.From || "DashBoard");
    }
  };
  const navigate = (path, option) => {
    updateWebURL({ ...option, Path: path });
    (navigation || props["navigation"]).navigate(path, option || {});
  };

  useEffect(() => {
    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      handleBackAction
    );
    return () => backHandler.remove();
  }, []);

  const handleValidateField = () => {
    let { email, cellPhone, name } = shareDetails,
      { email: Email, text } = shareOption,
      iValidatedArray = [];

    if (!name) iValidatedArray.push("name");

    if (Email && !email) iValidatedArray.push("email");
    if (text && !cellPhone) iValidatedArray.push("cellPhone");

    setValidateArray(iValidatedArray);
    return iValidatedArray.length !== 0;
  };

  const handleShareApp = async () => {
    if (handleValidateField()) return false;

    let { email, cellPhone, name } = shareDetails;
    if ((cellPhone || email) && name != "") {
      setShowSpinner(true);

      handleAPI({
        name: "SendShareApp",
        params: {
          Name: name,
          CellPhone: cellPhone,
          Email: email,
          Sender: route?.params?.userName || "" ,
          SessionId: route?.SessionId ||  (web) ? getQueryString("SessionId", "")  : "",
        },
      })
        .then((response) => {
          const jsonObject = JSON.parse(response);
          const status = jsonObject.Table[0].Column1
            ? JSON.parse(jsonObject.Table[0].Column1).Status
            : null;
          const statusMessage = jsonObject.Table[0].Column1
            ? JSON.parse(jsonObject.Table[0].Column1).StatusMessage
            : null;

          setStatusMessage({
            isShow: true,
            messageColor: status === "Success" ? "green" : "red",
            statusMessage: `${
              status === "Success" ? " Success: " : " Error: "
            }${statusMessage}`,
            iconName: status === "Success" ? "check" : "close",
          });
          setShowSpinner(false);
          setShareDetails({
            name: "",
            cellPhone: "",
            email: "",
          });
          setTimeout(() => {
            setStatusMessage({
              isShow: false,
              messageColor: "green",
              iconName: "check",
            });
          }, 4000);
        })
        .catch((err) => {
          console.error("Error Form SendShareApp =====> ", err);
          setShowSpinner(false);
        });
    } else {
      setShowSpinner(false);
    }
  };

  const ShareAppButton = memo(() => {
    return (
      <>
        {(shareOption["text"] || shareOption["email"]) && (
          <View
            style={[
              {
                marginTop: 20,
                alignItems: "flex-end",
              },
            ]}
          >
            <Button
              disabled={showSpinner}
              onPress={(e) => {
                handleShareApp();
              }}
              title={
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-end",
                    flex: 1,
                    width: 105,
                  }}
                >
                  <CustomText
                    bold={true}
                    style={{
                      fontSize: 16,
                      color: "#fff",
                    }}
                  >
                    Share App{"  "}
                  </CustomText>
                  {showSpinner ? (
                    <ArrowSpinner color="#fff" size={15} />
                  ) : (
                    <Icon
                      name="arrow-circle-right"
                      size={17}
                      color="#fff"
                      style={{
                        justifyContent: "space-around",
                      }}
                    />
                  )}
                </View>
              }
            />
          </View>
        )}
        <Separator />
        <Separator />
      </>
    );
  }, [showSpinner]);

  const handleShareOptionPress = (name) => {
    setShareOption({ ...shareOption, [name]: !shareOption[name] });
  };
  const handleShareDetails = (name, value) => {
    setShareDetails({ ...shareDetails, [name]: value });
  };

  return (
    <>
      <View style={[{ backgroundColor: "white", flex: 1 }]}>
        <View style={{ position: "absolute", zIndex: 1 }}>
          <TouchableOpacity activeOpacity={1} onPress={handleBackAction}>
            <CustomText
              bold={true}
              style={[
                { paddingVertical: 10, paddingHorizontal: 10 },
                web ? { cursor: "pointer" } : {},
              ]}
            >
              {web ? (
                <>
                  <Icon size={16} name="close" color="red" /> Close
                </>
              ) : (
                <>
                  <Icon name="angle-left" size={16} /> Back
                </>
              )}
            </CustomText>
          </TouchableOpacity>
        </View>
        <View style={{ alignItems: "center", marginTop: 5 }}>
          <CustomText style={{ fontSize: 22 }} bold={true}>
            Share App
          </CustomText>
        </View>
        <View style={{ flex: 1 }}>
          <ScrollContainer>
            <View style={{ marginHorizontal: 25 }}>
              <CustomText
                style={{
                  marginTop: 40,
                  fontSize: 18,
                }}
                bold={true}
              >
                How would you like to share the app?
              </CustomText>

              <View
                style={{
                  flexDirection: "row",
                  paddingVertical: 10,
                  justifyContent: "space-between",
                  marginTop: 20,
                }}
              >
                <Option
                  style={{ width: web ? "40%" : "48%" }}
                  text="Text"
                  value={shareOption["text"]}
                  onPress={() => handleShareOptionPress("text")}
                />
                <Option
                  style={{ width: "48%" }}
                  text="Email"
                  value={shareOption["email"]}
                  onPress={() => handleShareOptionPress("email")}
                />
              </View>
              {(shareOption["text"] || shareOption["email"]) && (
                <InputBox
                  validate={validateArray.includes("name")}
                  label="Name"
                  // autoFocus
                  placeholder="Enter Name"
                  value={shareDetails["name"]}
                  onChangeText={(text) => {
                    handleShareDetails("name", text);
                  }}
                />
              )}
              {shareOption["text"] && (
                <InputBox
                  validate={validateArray.includes("cellPhone")}
                  label="Cell Phone"
                  placeholder="Enter your Cell Phone"
                  keyboardType="numeric"
                  value={shareDetails["cellPhone"]}
                  onBlur={() => {
                    let text = shareDetails["cellPhone"] || "";
                    text = text
                      .replaceAll("-", "")
                      .replaceAll("(", "")
                      .replaceAll(")", "")
                      .replaceAll(" ", "");
                    text = FormatPhoneLogin(text);
                    handleShareDetails("cellPhone", text);
                  }}
                  onChangeText={(text) => {
                    handleShareDetails("cellPhone", text);
                  }}
                />
              )}
              {shareOption["email"] && (
                <InputBox
                  validate={validateArray.includes("email")}
                  label="Email Address"
                  value={shareDetails["email"]}
                  placeholder="Enter your Email Address"
                  onChangeText={(text) => {
                    handleShareDetails("email", text);
                  }}
                />
              )}
              <View>
                <CustomText>
                  Want to share the app on social media or other places? Use the
                  link below:
                </CustomText>
                {/* <Separator /> */}
                <View
                  style={{
                    flexDirection: "row",
                    borderWidth: 1,
                    borderColor: "#999",
                    marginTop: 10,
                  }}
                >
                  <CustomText
                    style={{
                      paddingHorizontal: 10,
                      paddingVertical: 15,
                      flex: 3,
                      backgroundColor: "rgba(0,0,0,.04)",
                    }}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                  >
                    https://www.directmortgage.com/Login/Presentation/Webforms/DownloadApp.htm
                  </CustomText>
                  <TouchableOpacity
                    activeOpacity={1}
                    onPress={async () => {
                      await Clipboard.setStringAsync(
                        "https://www.directmortgage.com/Login/Presentation/Webforms/DownloadApp.htm"
                      );
                      setStatusMessage({
                        isShow: true,
                        messageColor: "green",
                        statusMessage: " Link Copied.",
                        iconName: "check",
                      });
                      setTimeout(() => {
                        setStatusMessage({
                          isShow: false,
                          messageColor: "green",
                          iconName: "check",
                        });
                      }, 4000);
                    }}
                    style={{
                      width: 120,
                      borderLeftColor: "#999",
                      borderLeftWidth: 1,
                      paddingHorizontal: 10,
                      paddingVertical: 15,
                      flexDirection: "row",
                      flex: 1.5,
                    }}
                  >
                    <EvilIcons name="link" size={25} />
                    <CustomText bold={true}>Copy Link</CustomText>
                  </TouchableOpacity>
                </View>
              </View>
              <View
                style={{
                  justifyContent: "space-around",
                  marginTop: 20,
                  alignItems: "flex-end",
                }}
              >
                {statusMessage["isShow"] ? (
                  <CustomText style={{ color: statusMessage["messageColor"] }}>
                    <Icon
                      size={15}
                      name={statusMessage["iconName"]}
                      color={statusMessage["messageColor"]}
                    />

                    {statusMessage["statusMessage"] || ""}
                  </CustomText>
                ) : (
                  <CustomText> </CustomText>
                )}
              </View>
              <ShareAppButton />
            </View>
          </ScrollContainer>
        </View>
      </View>
      {!web && (
        <Footer iLoanId={0} navigate={navigate} From="DashBoard" UserId={0} />
      )}
    </>
  );
};
//Style Section
const styles = StyleSheet.create({
  errorMessage: {
    color: "red",
    fontSize: 15,
    padding: 10,
  },
  container: [
    {
      backgroundColor: "#fff",
      padding: 20,
      marginBottom: 20,
      marginLeft: 20,
      marginRight: 20,
      marginTop: 0,
      alignItems: "center",
      borderRadius: 5,
      overflow: "hidden",
      // justifyContent: "center",
      boxShadow: "3px 7px 10px 4px rgb(0 0 0 / 8%)",
      flex: 1,
    },
    web && { maxWidth: 420, minWidth: 420, overflow: "hidden", flex: "none" },
  ],
});

export default ShareApp;
